import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { Dispatch, SetStateAction } from 'react'

export type ModalProps = {
  title: string
  description: string
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
}

function CustomModal({
  show,
  setShow,
  title,
  description,
  onConfirm
}: ModalProps) {
  const handleClose = () => setShow(false)

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CustomModal
